module.exports = __webpack_public_path__ + "img/dollar.656cc0e5.svg";